// -- Helpers BEGIN
const windowLoad = require("%helpers%/window-load.js");
const loadImages = require("%helpers%/load-images.js");
// -- Helpers END


// -- Libraries BEGIN
require("fancybox")($);
// -- Libraries END


windowLoad(function() {
	const postsList = $(".sec-exclusive-news__inner");
	const post = postsList.find(".news-default-card:first-child");
	const exclusiveBtn = $(".sec-exclusive-news__btn");

	const fetchPosts = () => {
		new Array(4).fill(0).forEach(() => {
			postsList.append(post.clone());
		});
	};

	if (exclusiveBtn.length && postsList.length && post.length) {
		exclusiveBtn.click(function (e) {
			e.preventDefault();
			fetchPosts();
		});
	}
});

